export default "__VITE_ASSET__784485b1__"